<style>
	:global(.mdc-select__menu) {
		max-height: 200px !important;
	}
	:global(.smui-paper.smui-paper--color-primary.smui-paper--outlined) {
		border-color: initial;
	}
	:global(.smui-accordion .smui-accordion__panel.smui-accordion__panel--open > .smui-paper__content) {
		padding: 0px;
	}
	:global(.smui-accordion__header__title) {
		flex-basis: 0px;
	}
</style>

<script lang="ts">
	import Accordion, { Content, Header, Panel } from '@smui-extra/accordion';
	import Button, { Label } from '@smui/button';
	import Checkbox from '@smui/checkbox';
	import FormField from '@smui/form-field';
	import IconButton, { Icon } from '@smui/icon-button';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import DatePicker from '../../../../../../shared/components/common/Date/DatePicker.svelte';
	import AzioneComunicazione from '../../../../../../shared/models/PSCL/Misura/AzioneComunicazione';
	import AzioneMonitoraggio from '../../../../../../shared/models/PSCL/Misura/AzioneMonitoraggio';
	import PSCLMisura from '../../../../../../shared/models/PSCL/Misura/PSCLMisura';
	import PSCLMisuraAzioneComunicazione from '../../../../../../shared/models/PSCL/Misura/PSCLMisuraAzioneComunicazione';
	import PSCLMisuraAzioneMonitoraggio from '../../../../../../shared/models/PSCL/Misura/PSCLMisuraAzioneMonitoraggio';
	import TipoMisura from '../../../../../../shared/models/PSCL/Misura/TipoMisura';
	import { hasOriginalRoleSysAdmin  } from '../../../../../../shared/stores';

	export let data: PSCLMisura = null;
	export let psclCategoriaId: number = 0;
	export let tipiMisuraSelected: number[] = [];

	$: [dataTipiMisura, loadingTipiMisura, errorTipiMisura] = TipoMisura.getList({ categoriaMisuraId: psclCategoriaId });
	let tipiMisura: TipoMisura[] = [];

	$: if (tipiMisuraSelected?.length > 0 && $dataTipiMisura?.response && tipiMisura?.length == 0) {
		if (data?.tipoMisuraId) {
			const index = tipiMisuraSelected.indexOf(data.tipoMisuraId);
			if (index > -1) {
				tipiMisuraSelected.splice(index, 1);
			}
		}
		tipiMisura = $dataTipiMisura.response.filter((item) => !tipiMisuraSelected.includes(item.id));
	}

	let [dataAzioniComunicazione, loadingAzioniComunicazione, errorAzioniComunicazione] = AzioneComunicazione.getList();
	let [dataAzioniMonitoraggio, loadingAzioniMonitoraggio, errorAzioniMonitoraggio] = AzioneMonitoraggio.getList();

	let newPsclMisuraAzioneComunicazione: PSCLMisuraAzioneComunicazione = new PSCLMisuraAzioneComunicazione();
	let newPsclMisuraAzioneMonitoraggio: PSCLMisuraAzioneMonitoraggio = new PSCLMisuraAzioneMonitoraggio();

	let selectedTipoMisura: TipoMisura | undefined = undefined;
	$: selectedTipoMisura = data.tipoMisura;

	// Ottieni l'anno corrente
	const currentYear = new Date().getFullYear();
	// Crea una nuova data rappresentante il 1° gennaio dell'anno corrente
	let firstDayOfYear = new Date(currentYear, 0, 1);
	firstDayOfYear.setHours(0);
	firstDayOfYear.setMinutes(0);
	firstDayOfYear.setSeconds(0);

	let lastDayOfFifthYear = new Date(currentYear + 5, 11, 31);
	lastDayOfFifthYear.setHours(23);
	lastDayOfFifthYear.setMinutes(59);
	lastDayOfFifthYear.setSeconds(59);

	let pannelloAzioniComunicazione = false;
	let pannelloAzioniMonitoraggio = false;

	function addPsclMisuraAzioneComunicazione() {
		if (data.psclMisuraAzioneComunicazione) {
			newPsclMisuraAzioneComunicazione.selezionato = true;
			data.psclMisuraAzioneComunicazione = [...data.psclMisuraAzioneComunicazione, structuredClone(newPsclMisuraAzioneComunicazione)];
		}
	}

	function addPsclMisuraAzioneMonitoraggio() {
		if (data.psclMisuraAzioneMonitoraggio) {
			newPsclMisuraAzioneMonitoraggio.selezionato = true;
			data.psclMisuraAzioneMonitoraggio = [...data.psclMisuraAzioneMonitoraggio, structuredClone(newPsclMisuraAzioneMonitoraggio)];
		}
	}
</script>

<div class="grid grid-cols-2 gap-4 p-4 border border-black"> 
	<!--
    {#if $loadingTipiMisura}
        <FieldLoading customClass="col-span-2"/>
    {:else}
		{#if tipiMisura && tipiMisura?.length > 0 && selectedTipoMisura}
			<Select label={$_("page.pscl.detail.measure_type")} key={(tipoMisura) => `${(tipoMisura && tipoMisura?.id) || ''}`} bind:value={selectedTipoMisura} class="col-span-2" required>
				{#if tipiMisura && tipiMisura?.length > 0}
					{#each tipiMisura as tipoMisura (tipoMisura?.id)}
						{#if tipoMisura && tipoMisura?.nome}
							<Option value={tipoMisura} on:click="{() => { data.tipoMisura = tipoMisura; data.tipoMisuraId = tipoMisura.id; data.nomw = data.tipoMisura.nome; } }">{tipoMisura.nome}</Option>
						{/if}
					{/each}
				{/if}
			</Select>
		{/if}
    {/if}
	-->
	{#if data.tipoMisura?.descrizione}
		<div class="col-span-2">
			<label class="text-opacity-60 block mb-1 text-black">{$_('page.pscl.detail.description')}</label>
			<span class="block p-2 overflow-hidden break-words bg-gray-100 rounded-md" style="word-wrap: break-word; white-space: normal;">{data.tipoMisura.descrizione}</span>
		</div>
	{/if}
	<DatePicker label="{$_('page.pscl.detail.implementation_date')}" bind:value="{data.dataImplementazione}" bind:min="{firstDayOfYear}" bind:max="{lastDayOfFifthYear}" />
	<Input label="{$_('page.pscl.detail.management_cost')}" type="number" input$step="1" bind:value="{data.costoGestione}" />
	<Input label="{$_('page.pscl.detail.implementation_cost')}" type="number" input$step="1" bind:value="{data.costoImplementazione}" />
	<Input label="{$_('page.pscl.detail.note')}" bind:value="{data.note}" class="col-span-2" />
	<div class="col-span-2 pt-4 pb-3">
		<Accordion>
			<Panel square variant="outlined" color="primary" extend bind:open="{pannelloAzioniComunicazione}">
				<Header>
					{$_('page.pscl.detail.communication_actions')}
					<IconButton slot="icon" toggle pressed="{pannelloAzioniComunicazione}">
						<Icon class="material-icons" on>unfold_less</Icon>
						<Icon class="material-icons">unfold_more</Icon>
					</IconButton>
				</Header>
				<Content>
					<div class="gap-y-2 grid grid-cols-1 p-2">
						{#if data.psclMisuraAzioneComunicazione && data.psclMisuraAzioneComunicazione.length > 0}
							{#each data.psclMisuraAzioneComunicazione as psclMisuraAzioneComunicazione}
								<div class="lg:grid-cols-3 lg:gap-x-2 grid grid-cols-1 p-2 border border-black">
									<FormField>
										<Checkbox bind:checked="{psclMisuraAzioneComunicazione.selezionato}" />
										<span slot="label">{psclMisuraAzioneComunicazione?.descrizione}</span>
									</FormField>
									<Input
										label="{$_('page.pscl.detail.cost')} (€)"
										type="number"
										input$step="1"
										bind:value="{psclMisuraAzioneComunicazione.costo}"
									/>
									<Input label="{$_('page.pscl.detail.note')}" bind:value="{psclMisuraAzioneComunicazione.note}" />
								</div>
							{/each}
						{/if}
					</div>
					<div class="gap-y-2 grid grid-cols-1 p-2">
						<div class="lg:grid-cols-3 lg:gap-x-2 grid grid-cols-1 p-2 border border-black">
							<Input label="{$_('global.other')}" bind:value="{newPsclMisuraAzioneComunicazione.descrizione}" required />
							<Input
								label="{$_('page.pscl.detail.cost')} (€)"
								type="number"
								input$step="1"
								bind:value="{newPsclMisuraAzioneComunicazione.costo}"
							/>
							<Input label="{$_('page.pscl.detail.note')}" bind:value="{newPsclMisuraAzioneComunicazione.note}" />
							<div class="lg:justify-self-end col-span-3 pt-2">
								<Button
									disabled="{!newPsclMisuraAzioneComunicazione.descrizione}"
									on:click="{addPsclMisuraAzioneComunicazione}"
									class="lg:w-40"
									type="button"
									variant="raised"
								>
									<Label>{$_('global.add')}</Label>
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</Panel>
		</Accordion>
		<Accordion>
			<Panel square variant="outlined" color="primary" extend bind:open="{pannelloAzioniMonitoraggio}">
				<Header>
					{$_('page.pscl.detail.monitoring_actions')}
					<IconButton slot="icon" toggle pressed="{pannelloAzioniMonitoraggio}">
						<Icon class="material-icons" on>unfold_less</Icon>
						<Icon class="material-icons">unfold_more</Icon>
					</IconButton>
				</Header>
				<Content>
					<div class="gap-y-2 grid grid-cols-1 p-2">
						{#if data.psclMisuraAzioneMonitoraggio && data.psclMisuraAzioneMonitoraggio.length > 0}
							{#each data.psclMisuraAzioneMonitoraggio as psclMisuraAzioneMonitoraggio}
								<div class="lg:grid-cols-3 lg:gap-x-2 grid grid-cols-1 p-2 border border-black">
									<FormField>
										<Checkbox bind:checked="{psclMisuraAzioneMonitoraggio.selezionato}" />
										<span slot="label">{psclMisuraAzioneMonitoraggio?.descrizione}</span>
									</FormField>
									<Input
										label="{$_('page.pscl.detail.cost')} (€)"
										type="number"
										input$step="1"
										bind:value="{psclMisuraAzioneMonitoraggio.costo}"
									/>
									<Input label="{$_('page.pscl.detail.note')}" bind:value="{psclMisuraAzioneMonitoraggio.note}" />
								</div>
							{/each}
						{/if}
					</div>
					<div class="gap-y-2 grid grid-cols-1 p-2">
						<div class="lg:grid-cols-3 lg:gap-x-2 grid grid-cols-1 p-2 border border-black">
							<Input label="{$_('global.other')}" bind:value="{newPsclMisuraAzioneMonitoraggio.descrizione}" required />
							<Input
								label="{$_('page.pscl.detail.cost')} (€)"
								type="number"
								input$step="1"
								bind:value="{newPsclMisuraAzioneMonitoraggio.costo}"
							/>
							<Input label="{$_('page.pscl.detail.note')}" bind:value="{newPsclMisuraAzioneMonitoraggio.note}" />
							<div class="lg:justify-self-end col-span-3 pt-2">
								<Button
									disabled="{!newPsclMisuraAzioneMonitoraggio.descrizione}"
									on:click="{addPsclMisuraAzioneMonitoraggio}"
									class="lg:w-40"
									type="button"
									variant="raised"
								>
									<Label>{$_('page.pscl.detail.add')}</Label>
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</Panel>
		</Accordion>
	</div>
</div>
